import React, { useEffect, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
  Divider,
} from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import mapValues from 'lodash/mapValues'
import CustomAlert from '../../CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { dateFormatter, sleep } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { createSalesBillsDocument } from '../../../Backend/firebase/sales-bills'
import { getProductAndSalesDocumentWithUserId } from '../../../Backend/firebase/product-and-sales'
import { getClientDocumentWithUserId } from '../../../Backend/firebase/party'
import { getTeamDocumentWithUserId } from '../../../Backend/firebase/team'
import { getProductStockDocumentWithUserId, updateProductStockDocument } from '../../../Backend/firebase/product-stock'
import db from '../../../Backend/firebase/firebase'
const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function UpdateStock() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [TransferDate, setTransferDate] = useState(dateFormatter(new Date()))
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const { userData } = CheckUserProvider()
  const [teamMember, setTeamMember] = useState([]);
  const [ProductEntry, setProductEntry] = useState([])
  const [productItems, setProductItems] = useState([])
  const [searchItem, setSearchItem] = useState([])
  const [ProductStockQuantity, setProductStockQuantity] = useState(0)
  var batch = db.batch()

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }
  useEffect(async () => {
    if (userData) {
        try {
            const getTeam = await getTeamDocumentWithUserId(userData.uid);
            setTeamMember(getTeam);
        } catch(error) {
            console.log("Error Occur in Get Team", error)
        }
    }
}, [userData]);

  useEffect(async () => {
    if (userData) {
      try {
        const getProductsStocks = await getProductStockDocumentWithUserId(
          userData.uid,
        )
        setProductItems(getProductsStocks.map((item)=> {
          return {
            ...item.ProductEntry[0], 
            ProductID: item.ProductID, 
            ProductUniqueID: item.ProductUniqueID,
            TotalStock: item.TotalStock, 
            userId: item.userId
          }
        }))
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const handleSaveSubmit = () => {
    handleSubmit(async (data) => {
      setIsLoading(true)
      if(ProductEntry && ProductEntry.length > 0) {
        let stockJson = ProductEntry.map((obj) => {
          var updateStocks = {}
          updateStocks.TransferedTo = data.TransferedTo;
          updateStocks.TransferDate = TransferDate;
          updateStocks.ProductID = obj.ProductID;
          updateStocks.TotalStock = obj.TotalStock - obj.ProductStockQuantity;
   
          return updateStocks;
      });
      try {
        console.log("stockJson",stockJson)
        setIsLoading(true);
        await stockJson.map(async (doc)=> {
            const collectionRef = await db.collection('ProductStock').doc(doc.ProductID);
            batch.update(collectionRef, doc);
        });
        batch.commit().then(() => {
            setNotificationMessage('Stock updated successfully.');
            setOpenNotify(true);
            setAlertType('success');
            setIsLoading(false);
            setTimeout(routeToPages, 1500);
          }).catch((error)=> {
            console.error(error);
            setNotificationMessage('Something went wrong, Please try again later!!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
          });
        }  catch (error) {
          console.error(error);
          setNotificationMessage('Something went wrong, Please try again later!!');
          setOpenNotify(true);
          setAlertType('error');
          setIsLoading(false);
        }
      } else {
        setNotificationMessage(
          'Please Minimum Add One Product!',
        )
        setOpenNotify(true)
        setAlertType('error')
        setIsLoading(false)
      }
    })()
  }

  const routeToPages = () => {
    history.push('/retailer/inventories')
  }

  const handleTransferDateChange = (e) => {
    setTransferDate(dateFormatter(e.target.value))
  }

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    console.log('handleOnSearch', string, results)
  }

  const handleOnHover = (result) => {
    // the item hovered
    console.log('handleOnHover', result)
  }

  const onTapAddProductButton = () => {
    // the item selected
    setProductEntry([
      ...ProductEntry,
      { ...searchItem, ProductStockQuantity: ProductStockQuantity },
    ])
  }

  const handleOnSelect = (item) => {
    // the item selected
    setSearchItem(item)
  }

  const handleOnFocus = () => {
    console.log('Focused')
  }

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.ProductName}
        </span>
      </>
    )
  }

  const onTapOfDeleteProduct = (index) => {
    if (ProductEntry.length !== 1) {
        const values = [...ProductEntry]
        values.splice(index, 1)
        setProductEntry(values)
    }
  }

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Creating New Sales Bill page." />
          <title>Update Stock | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <>
                <h5 className="mt-3">Order Details:</h5>
                <div className="col-md-6 mb-2">
                  Transfered To(Team Name)
                  <select
                    className={classNames("form-select registerEmp__textbox")} 
                    aria-label="Default select example"
                    name="TransferedTo" ref={register({
                        required: 'Please select Team Member!',
                        validate: {
                            defaultValue: value => value !== "Select Option" || 'Please select Team Member!'
                        }
                    })} defaultValue="Select Team Member" >
                      {(teamMember && teamMember.length > 0) && <>
                        <option value={'Select Option'}>{'Select Option'}</option>
                        {teamMember.map((item) =>  <option value={`${item.MemberName} - ${item.MemberEmail}`}>{`${item.MemberName} - ${item.MemberEmail}`}</option>)}
                      </>}
                  </select>
                </div>
                <div className="col-md-6 mb-2 mt-2">
                  Date
                  <DatePickerComponent
                    id="TransferDate"
                    name="TransferDate"
                    value={TransferDate}
                    cssclassName="e-outline"
                    onChange={(e) => handleTransferDateChange(e)}
                    ref={register()}
                  />
                </div>
                <h5 className="mt-3">Product Details:</h5>
                <div className="row mb-3">
                  <div className="col-md-7 mb-2">
                    <ReactSearchAutocomplete
                      items={productItems}
                      placeholder="Search Product..."
                      fuseOptions={{ keys: ['ProductName'] }}
                      // necessary, otherwise the results will be blank
                      resultStringKeyName="ProductName"
                      onSearch={handleOnSearch}
                      onHover={handleOnHover}
                      onSelect={handleOnSelect}
                      onFocus={handleOnFocus}
                      autoFocus
                      formatResult={formatResult}
                      styling={{
                        borderRadius: '8px',
                      }}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    {/*  */}
                    <input
                      type="number"
                      className={classNames(
                        'form-control registerEmp__textbox',
                      )}
                      placeholder="Product Quantity"
                      name="ProductStockQuantity"
                      autoComplete="none"
                      onChange={(event) =>
                        setProductStockQuantity(event.target.value)
                      }
                      ref={register()}
                    />
                  </div>
                  <div className="col-md-2 mb-2">
                    {/*  */}
                    <div className="addBox">
                      {/* <label className="login__textboxLabel jsm__textboxLabel">{} </label> */}
                      <Button
                        onClick={onTapAddProductButton}
                        variant="contained"
                        className="registerEmp__btnLogin jsmAdd"
                      >
                        {'Add'}
                      </Button>
                    </div>
                  </div>
                </div>
                {ProductEntry && ProductEntry.length > 0 && (
                  <table className="table">
                    <thead>
                      <td>S.No</td>
                      <td>Product</td>
                      <td>Quantity</td>
                      <td>Exp Date</td>
                      <td>HSN Code</td>
                      <td>Batch No</td>
                      <td>Action</td>
                    </thead>
                    <tbody>
                      {ProductEntry.map((item, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item?.ProductName}</td>
                            <td>{item?.ProductStockQuantity}</td>
                            <td>{item?.ExpiryDate ? item?.ExpiryDate : 'NA'}</td>
                            <td>{item?.ExpiryDate ? item?.HSNCode : "NA"}</td>
                            <td>{item?.ExpiryDate ? item?.BatchNo : "NA"}</td>
                            <td className="deleteCursor">
                              <DeleteIcon onClick={()=> onTapOfDeleteProduct(index)} />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                )}
              </>

              <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  <div className="p-2">
                    <Button
                      type="submit"
                      name="preview"
                      value="preview"
                      variant="contained"
                      onClick={handleSaveSubmit}
                      className="registerEmp__btnLogin preview"
                    >
                      {'Update Stock'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default UpdateStock
